module.exports = {"360803001":"河东街道","360803002":"滨江街道","360803100":"天玉镇","360803101":"值夏镇","360803102":"新圩镇","360803103":"富滩镇","360803104":"富田镇","360803105":"文陂镇","360803201":"东固畲族少数民族乡","360803400":"青原区河东经济开发区","360803500":"东固垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360803.json
// module id = 1419
// module chunks = 0